import { render, staticRenderFns } from "./RuleManagerPiExactMatchRuleDetails.vue?vue&type=template&id=06f78436&scoped=true&"
import script from "./RuleManagerPiExactMatchRuleDetails.vue?vue&type=script&lang=js&"
export * from "./RuleManagerPiExactMatchRuleDetails.vue?vue&type=script&lang=js&"
import style0 from "./RuleManagerPiExactMatchRuleDetails.vue?vue&type=style&index=0&id=06f78436&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f78436",
  null
  
)

export default component.exports